import { getRequest } from '@/core';
import { tripAddresses } from '@/requests';

export default async function getFilteredTripAddressesRequest(filter) {
	let url = tripAddresses.getPath();
	try {
		let response = await getRequest(url, filter);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
